import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
import { AddedProductVariantFragmentDoc } from '../../fragments/__generated__/AddedProductVariant.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AddProductVariantToCartMutationVariables = Types.Exact<{
  pk: Types.Scalars['Int']['input'];
  quantity: Types.Scalars['Int']['input'];
}>;


export type AddProductVariantToCartMutation = { addVariantToCart: { quantity: number, errors: Array<{ field: string, messages: Array<string> }>, product: { id: string, pk: number } | null, cartLine: { id: string, pk: number } | null, variant: { id: string, pk: number, isSupply: boolean, shippingRequired: boolean, sku: string, stockQuantity: number, outOfStockStatus: Types.OutOfStockStatusEnum, stockStatus: Types.OutOfStockStatusEnum | null, priceRange: { id: string, currency: string, discount: { max: number, min: number }, undiscount: { max: number, min: number } }, allImages: Array<{ id: string, pk: number, alt: string, thumbnailUrl: string | null, url: string }>, properties: Array<{ id: number, pk: number, valueName: string, attributeName: string }> } | null } };

export type AddFullProductKitToCartMutationVariables = Types.Exact<{
  pk: Types.Scalars['Int']['input'];
  cartType?: Types.InputMaybe<Types.CartTypeEnum>;
  quantity: Types.Scalars['Int']['input'];
}>;


export type AddFullProductKitToCartMutation = { addFullKitToCart: { quantity: number, supplyLinesJson: any, warnings: Array<{ field: string, messages: Array<string> }>, product: { id: string, pk: number } | null, cartLine: { id: string, pk: number } | null, variant: { isInCart: boolean, cartQuantity: number, cartLines: Array<number>, id: string, pk: number, isSupply: boolean, shippingRequired: boolean, sku: string, stockQuantity: number, outOfStockStatus: Types.OutOfStockStatusEnum, stockStatus: Types.OutOfStockStatusEnum | null, priceRange: { id: string, currency: string, discount: { max: number, min: number }, undiscount: { max: number, min: number } }, allImages: Array<{ id: string, pk: number, alt: string, thumbnailUrl: string | null, url: string }>, properties: Array<{ id: number, pk: number, valueName: string, attributeName: string }> } | null } };

export type AddProductKitToCartMutationVariables = Types.Exact<{
  pk: Types.Scalars['Int']['input'];
  variants: Array<Types.KitFormInput> | Types.KitFormInput;
  setAsDefault?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type AddProductKitToCartMutation = { addKitToCart: { supplyLinesJson: any, quantity: number, errors: Array<{ field: string, messages: Array<string> }>, warnings: Array<{ field: string, messages: Array<string> }>, product: { id: string, pk: number } | null, cartLine: { id: string, pk: number } | null, variant: { id: string, pk: number, isSupply: boolean, shippingRequired: boolean, sku: string, stockQuantity: number, outOfStockStatus: Types.OutOfStockStatusEnum, stockStatus: Types.OutOfStockStatusEnum | null, priceRange: { id: string, currency: string, discount: { max: number, min: number }, undiscount: { max: number, min: number } }, allImages: Array<{ id: string, pk: number, alt: string, thumbnailUrl: string | null, url: string }>, properties: Array<{ id: number, pk: number, valueName: string, attributeName: string }> } | null } };

export type CartUpdateProductVariantMutationVariables = Types.Exact<{
  cartLine: Types.Scalars['Int']['input'];
  variant: Types.Scalars['Int']['input'];
  quantity: Types.Scalars['Int']['input'];
  cartType?: Types.InputMaybe<Types.CartTypeEnum>;
}>;


export type CartUpdateProductVariantMutation = { cartUpdateVariant: { errors: Array<{ field: string, messages: Array<string> }> } };

export type CartUpdateProductKitMutationVariables = Types.Exact<{
  cartLine: Types.Scalars['Int']['input'];
  variants: Array<Types.KitFormInput> | Types.KitFormInput;
  cartType?: Types.InputMaybe<Types.CartTypeEnum>;
  setAsDefault?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type CartUpdateProductKitMutation = { cartUpdateKit: { errors: Array<string> } };

export type AddProductVariantToWholesaleCartMutationVariables = Types.Exact<{
  pk: Types.Scalars['Int']['input'];
  quantity: Types.Scalars['Int']['input'];
}>;


export type AddProductVariantToWholesaleCartMutation = { addVariantToCart: { quantity: number, errors: Array<{ field: string, messages: Array<string> }>, product: { id: string, pk: number } | null, cartLine: { id: string, pk: number } | null, variant: { id: string, pk: number, stockQuantity: number, isInCart: boolean, cartQuantity: number } | null } };


export const AddProductVariantToCartDocument = gql`
    mutation AddProductVariantToCart($pk: Int!, $quantity: Int!) {
  addVariantToCart(variant: $pk, quantity: $quantity) {
    errors {
      field
      messages
    }
    quantity
    product {
      id
      pk
    }
    cartLine {
      id
      pk
    }
    variant {
      ...AddedProductVariantFragment
    }
  }
}
    ${AddedProductVariantFragmentDoc}`;
export type AddProductVariantToCartMutationFn = Apollo.MutationFunction<AddProductVariantToCartMutation, AddProductVariantToCartMutationVariables>;

/**
 * __useAddProductVariantToCartMutation__
 *
 * To run a mutation, you first call `useAddProductVariantToCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProductVariantToCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProductVariantToCartMutation, { data, loading, error }] = useAddProductVariantToCartMutation({
 *   variables: {
 *      pk: // value for 'pk'
 *      quantity: // value for 'quantity'
 *   },
 * });
 */
export function useAddProductVariantToCartMutation(baseOptions?: Apollo.MutationHookOptions<AddProductVariantToCartMutation, AddProductVariantToCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProductVariantToCartMutation, AddProductVariantToCartMutationVariables>(AddProductVariantToCartDocument, options);
      }
export type AddProductVariantToCartMutationHookResult = ReturnType<typeof useAddProductVariantToCartMutation>;
export type AddProductVariantToCartMutationResult = Apollo.MutationResult<AddProductVariantToCartMutation>;
export type AddProductVariantToCartMutationOptions = Apollo.BaseMutationOptions<AddProductVariantToCartMutation, AddProductVariantToCartMutationVariables>;
export const AddFullProductKitToCartDocument = gql`
    mutation AddFullProductKitToCart($pk: Int!, $cartType: CartTypeEnum = DEFAULT, $quantity: Int!) {
  addFullKitToCart(variant: $pk, cartType: $cartType, quantity: $quantity) {
    quantity
    supplyLinesJson
    warnings {
      field
      messages
    }
    product {
      id
      pk
    }
    cartLine {
      id
      pk
    }
    variant {
      ...AddedProductVariantFragment
      isInCart(cartType: $cartType)
      cartQuantity(cartType: $cartType)
      cartLines(cartType: $cartType)
    }
  }
}
    ${AddedProductVariantFragmentDoc}`;
export type AddFullProductKitToCartMutationFn = Apollo.MutationFunction<AddFullProductKitToCartMutation, AddFullProductKitToCartMutationVariables>;

/**
 * __useAddFullProductKitToCartMutation__
 *
 * To run a mutation, you first call `useAddFullProductKitToCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFullProductKitToCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFullProductKitToCartMutation, { data, loading, error }] = useAddFullProductKitToCartMutation({
 *   variables: {
 *      pk: // value for 'pk'
 *      cartType: // value for 'cartType'
 *      quantity: // value for 'quantity'
 *   },
 * });
 */
export function useAddFullProductKitToCartMutation(baseOptions?: Apollo.MutationHookOptions<AddFullProductKitToCartMutation, AddFullProductKitToCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddFullProductKitToCartMutation, AddFullProductKitToCartMutationVariables>(AddFullProductKitToCartDocument, options);
      }
export type AddFullProductKitToCartMutationHookResult = ReturnType<typeof useAddFullProductKitToCartMutation>;
export type AddFullProductKitToCartMutationResult = Apollo.MutationResult<AddFullProductKitToCartMutation>;
export type AddFullProductKitToCartMutationOptions = Apollo.BaseMutationOptions<AddFullProductKitToCartMutation, AddFullProductKitToCartMutationVariables>;
export const AddProductKitToCartDocument = gql`
    mutation AddProductKitToCart($pk: Int!, $variants: [KitFormInput!]!, $setAsDefault: Boolean = false) {
  addKitToCart(
    supplyVariant: $pk
    variants: $variants
    setAsDefault: $setAsDefault
  ) {
    errors {
      field
      messages
    }
    supplyLinesJson
    warnings {
      field
      messages
    }
    quantity
    product {
      id
      pk
    }
    cartLine {
      id
      pk
    }
    variant {
      ...AddedProductVariantFragment
    }
  }
}
    ${AddedProductVariantFragmentDoc}`;
export type AddProductKitToCartMutationFn = Apollo.MutationFunction<AddProductKitToCartMutation, AddProductKitToCartMutationVariables>;

/**
 * __useAddProductKitToCartMutation__
 *
 * To run a mutation, you first call `useAddProductKitToCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProductKitToCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProductKitToCartMutation, { data, loading, error }] = useAddProductKitToCartMutation({
 *   variables: {
 *      pk: // value for 'pk'
 *      variants: // value for 'variants'
 *      setAsDefault: // value for 'setAsDefault'
 *   },
 * });
 */
export function useAddProductKitToCartMutation(baseOptions?: Apollo.MutationHookOptions<AddProductKitToCartMutation, AddProductKitToCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProductKitToCartMutation, AddProductKitToCartMutationVariables>(AddProductKitToCartDocument, options);
      }
export type AddProductKitToCartMutationHookResult = ReturnType<typeof useAddProductKitToCartMutation>;
export type AddProductKitToCartMutationResult = Apollo.MutationResult<AddProductKitToCartMutation>;
export type AddProductKitToCartMutationOptions = Apollo.BaseMutationOptions<AddProductKitToCartMutation, AddProductKitToCartMutationVariables>;
export const CartUpdateProductVariantDocument = gql`
    mutation CartUpdateProductVariant($cartLine: Int!, $variant: Int!, $quantity: Int!, $cartType: CartTypeEnum = DEFAULT) {
  cartUpdateVariant(
    cartLine: $cartLine
    variant: $variant
    quantity: $quantity
    cartType: $cartType
  ) {
    errors {
      field
      messages
    }
  }
}
    `;
export type CartUpdateProductVariantMutationFn = Apollo.MutationFunction<CartUpdateProductVariantMutation, CartUpdateProductVariantMutationVariables>;

/**
 * __useCartUpdateProductVariantMutation__
 *
 * To run a mutation, you first call `useCartUpdateProductVariantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCartUpdateProductVariantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cartUpdateProductVariantMutation, { data, loading, error }] = useCartUpdateProductVariantMutation({
 *   variables: {
 *      cartLine: // value for 'cartLine'
 *      variant: // value for 'variant'
 *      quantity: // value for 'quantity'
 *      cartType: // value for 'cartType'
 *   },
 * });
 */
export function useCartUpdateProductVariantMutation(baseOptions?: Apollo.MutationHookOptions<CartUpdateProductVariantMutation, CartUpdateProductVariantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CartUpdateProductVariantMutation, CartUpdateProductVariantMutationVariables>(CartUpdateProductVariantDocument, options);
      }
export type CartUpdateProductVariantMutationHookResult = ReturnType<typeof useCartUpdateProductVariantMutation>;
export type CartUpdateProductVariantMutationResult = Apollo.MutationResult<CartUpdateProductVariantMutation>;
export type CartUpdateProductVariantMutationOptions = Apollo.BaseMutationOptions<CartUpdateProductVariantMutation, CartUpdateProductVariantMutationVariables>;
export const CartUpdateProductKitDocument = gql`
    mutation CartUpdateProductKit($cartLine: Int!, $variants: [KitFormInput!]!, $cartType: CartTypeEnum = DEFAULT, $setAsDefault: Boolean = false) {
  cartUpdateKit(
    cartLine: $cartLine
    variants: $variants
    cartType: $cartType
    setAsDefault: $setAsDefault
  ) {
    errors
  }
}
    `;
export type CartUpdateProductKitMutationFn = Apollo.MutationFunction<CartUpdateProductKitMutation, CartUpdateProductKitMutationVariables>;

/**
 * __useCartUpdateProductKitMutation__
 *
 * To run a mutation, you first call `useCartUpdateProductKitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCartUpdateProductKitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cartUpdateProductKitMutation, { data, loading, error }] = useCartUpdateProductKitMutation({
 *   variables: {
 *      cartLine: // value for 'cartLine'
 *      variants: // value for 'variants'
 *      cartType: // value for 'cartType'
 *      setAsDefault: // value for 'setAsDefault'
 *   },
 * });
 */
export function useCartUpdateProductKitMutation(baseOptions?: Apollo.MutationHookOptions<CartUpdateProductKitMutation, CartUpdateProductKitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CartUpdateProductKitMutation, CartUpdateProductKitMutationVariables>(CartUpdateProductKitDocument, options);
      }
export type CartUpdateProductKitMutationHookResult = ReturnType<typeof useCartUpdateProductKitMutation>;
export type CartUpdateProductKitMutationResult = Apollo.MutationResult<CartUpdateProductKitMutation>;
export type CartUpdateProductKitMutationOptions = Apollo.BaseMutationOptions<CartUpdateProductKitMutation, CartUpdateProductKitMutationVariables>;
export const AddProductVariantToWholesaleCartDocument = gql`
    mutation AddProductVariantToWholesaleCart($pk: Int!, $quantity: Int!) {
  addVariantToCart(variant: $pk, quantity: $quantity, cartType: WHOLESALE) {
    errors {
      field
      messages
    }
    quantity
    product {
      id
      pk
    }
    cartLine {
      id
      pk
    }
    variant {
      id
      pk
      stockQuantity
      isInCart(cartType: WHOLESALE)
      cartQuantity(cartType: WHOLESALE)
    }
  }
}
    `;
export type AddProductVariantToWholesaleCartMutationFn = Apollo.MutationFunction<AddProductVariantToWholesaleCartMutation, AddProductVariantToWholesaleCartMutationVariables>;

/**
 * __useAddProductVariantToWholesaleCartMutation__
 *
 * To run a mutation, you first call `useAddProductVariantToWholesaleCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProductVariantToWholesaleCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProductVariantToWholesaleCartMutation, { data, loading, error }] = useAddProductVariantToWholesaleCartMutation({
 *   variables: {
 *      pk: // value for 'pk'
 *      quantity: // value for 'quantity'
 *   },
 * });
 */
export function useAddProductVariantToWholesaleCartMutation(baseOptions?: Apollo.MutationHookOptions<AddProductVariantToWholesaleCartMutation, AddProductVariantToWholesaleCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProductVariantToWholesaleCartMutation, AddProductVariantToWholesaleCartMutationVariables>(AddProductVariantToWholesaleCartDocument, options);
      }
export type AddProductVariantToWholesaleCartMutationHookResult = ReturnType<typeof useAddProductVariantToWholesaleCartMutation>;
export type AddProductVariantToWholesaleCartMutationResult = Apollo.MutationResult<AddProductVariantToWholesaleCartMutation>;
export type AddProductVariantToWholesaleCartMutationOptions = Apollo.BaseMutationOptions<AddProductVariantToWholesaleCartMutation, AddProductVariantToWholesaleCartMutationVariables>;